module.exports = __webpack_public_path__ + "static/img/go-bg.3c52901c.png";